import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { AbMoneyPipe } from './ab-money.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';

@Pipe({
  name: 'supFraction'
})
export class SupFractionPipe implements PipeTransform {
  constructor(
    private moneyPipe: AbMoneyPipe,
    private safeHtmlPipe: SafeHtmlPipe
  ) {}

  transform(value: number, noHtml?: boolean): SafeHtml {
    let money = this.moneyPipe.transform(value);
    const moneyArray = money.split('.');
    money = noHtml
      ? `${moneyArray[0]}.${moneyArray[1]}`
      : `${moneyArray[0]}.<sup>${moneyArray[1]}</sub>`;

    return this.safeHtmlPipe.transform(money);
  }
}
